import { render, staticRenderFns } from "./IndustrialControlAndERP.vue?vue&type=template&id=32054b69&scoped=true"
import script from "./IndustrialControlAndERP.vue?vue&type=script&lang=js"
export * from "./IndustrialControlAndERP.vue?vue&type=script&lang=js"
import style0 from "./IndustrialControlAndERP.vue?vue&type=style&index=0&id=32054b69&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32054b69",
  null
  
)

export default component.exports